// extracted by mini-css-extract-plugin
export default {"container":"ChartCard_container__ZiNpp","percentageContainer":"ChartCard_percentageContainer__yqsOv","colorBox":"ChartCard_colorBox__T26NI"};